import { FilterServiceService } from 'src/app/_services/filter-service.service';
import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { HttpParams } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Paginator } from 'primeng/paginator';
import { BaseService } from 'src/app/_services/base.service';
import { GlobalService } from 'src/app/_services/global.service';
import { InventoryService } from 'src/app/_services/inventory.service';
import { environment } from 'src/environments/environment';
import { ConnMessageService } from 'src/app/_services/conn-message.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService } from 'primeng/api';
import { formatDate } from '@angular/common';
import { Router } from '@angular/router';
import { ProductsService } from 'src/app/_services/products.service';

@Component({
  selector: 'app-inventory-count',
  templateUrl: './inventory-count.component.html',
  styleUrls: ['./inventory-count.component.scss']
})

export class InventoryCountComponent implements OnInit {
  dataList: any = null
  locations: any = []

  page = 0
  rows = 10
  first = 0
  totalRecords = 0

  selectAll = false
  searchText = ''
  lastSearchText = ''
  autoAdjustQty = true

  selectedRow: any = ''
  showLatestProductPanel = false

  //order
  orderParam = ''
  orderBy = ''

  _globals = GlobalService
  @ViewChild('p', { static: false }) paginator: Paginator;


  colheader = [[
    'Barcode', 'SkuCode', 'Item Name'
    , 'Opening Stock', 'Used Since', 'Now on Hand'
  ]];

  colflds = ['barcode', 'skuCode', 'itemName',
    'openingStock', 'usedSince', 'stockInHand'];

  csvcols = []
  exportColumns: any = ''

  constructor(
    // private fb: FormBuilder,
    private _bs: BaseService,
    private _inventoryService: InventoryService,
    private _connMessageService: ConnMessageService,
    private _spinner: NgxSpinnerService,
    private _confirmationService: ConfirmationService,
    private _abd: AppBaseDataService,
    private _router: Router,
    private _filterService: FilterServiceService,
    private _productService: ProductsService,
  ) {
    this.csvcols = this._abd.makeCsvCols(this.colheader, this.colflds)
    this.exportColumns = this.csvcols.map(col => ({ title: col.header, dataKey: col.field }))
  }

  ngOnInit(): void {
    this._globals.componentName = 'Inventory Count'
    this._abd.searchText = ''

  }

  ngAfterViewInit() {
    let ti = null
    ti = setInterval(() => {
      let ppages = this._filterService.getPages(this._globals.componentName)
      if (ppages) {
        let lastpage = parseInt(ppages.page)
        if (lastpage < 0) lastpage = 0
        if (lastpage > 0) {
          this.page = lastpage
          this.first = lastpage * this.rows
        }
      }

      let filter = this._filterService.getFilters(this._globals.componentName)
      if (filter) {
        if (filter.searchText) this._filterService.searchText = filter.searchText
        const rr = this._abd.getProductSellTypeFilter(filter.selectedProductSellTypeFilter)
        if (filter.selectedProductSellTypeFilter) this._filterService.selectedProductSellTypeFilter = rr
        // if (filter.startDate) this._filterService.dateRange[0] = new Date(filter.startDate)
        // if (filter.endDate) this._filterService.dateRange[1] = new Date(filter.endDate)

        if (filter.selectedLocation) this._filterService.selectedLocation = filter.selectedLocation
        if (filter.selectedDepartment) this._filterService.selectedDepartment = filter.selectedDepartment
        if (filter.selectedVendor) this._filterService.selectedVendor = filter.selectedVendor
        if (filter.selectedManufacturer) this._filterService.selectedManufacturer = filter.selectedManufacturer
        if (filter.selectedCategory) this._filterService.selectedCategory = filter.selectedCategory
      }

      let oorderby = this._filterService.getOrderby(this._globals.componentName)
      if (oorderby) {
        this.orderParam = oorderby.orderParam
        this.orderBy = oorderby.orderBy
      }


      this.getInventoryCountInitData()
      clearInterval(ti)
    }, 700);
  }

  ngOnDestroy() {
    this._globals.componentName = ''
  }

  getInventoryCountInitData() {
    this.locations = this._abd.initActLocations()
    this._abd.selectedLocation = this.locations[0]
    if(!this._filterService.selectedLocation) this._filterService.selectedLocation = this.locations[0]
    this._abd.selectedCategory = null
    this._abd.selectedCategory = null
    this._abd.selectedVendor = null
    this._abd.selectedManufacturer = null
    this.getDataList()
  }

  makeParams() {
    let params = new HttpParams();
    let startDate: any = null
    let endDate: any = null


    if (!this._filterService.dateRange || this._filterService.dateRange.length < 1) {
      this._filterService.dateRange = []
      startDate = (new Date(new Date().setDate(new Date().getDate() - 7)))
      endDate = (new Date())
    } else {
      startDate = new Date(this._filterService.dateRange[0])
      endDate = new Date(this._filterService.dateRange[1])
    }
    // startDate=new Date(2010, 2, 30)
    params = params.append('startDate', formatDate(new Date(startDate), 'MM/dd/yyyy', 'en-US'));
    params = params.append('endDate', formatDate(new Date(endDate), 'MM/dd/yyyy', 'en-US'));
    // console.log(this._filterService.selectedLocation);

    if (this._filterService.selectedLocation) params = params.append('locationId', this._filterService.selectedLocation?.locationId?.toString());
    if (this._filterService.selectedDepartment) params = params.append('departId', this._filterService.selectedDepartment?.id?.toString());
    if (this._filterService.selectedCategory) params = params.append('categoryId', this._filterService.selectedCategory?.id?.toString());
    if (this._filterService.selectedVendor) params = params.append('vendorId', this._filterService.selectedVendor?.id?.toString());
    if (this._filterService.selectedManufacturer) params = params.append('manufactureId', this._filterService.selectedManufacturer?.id.toString());

    try {
      if (this.searchTextSearch.length > 0) this.page = this.paginator.paginatorState.page - 1
      else this.page = this.paginator.paginatorState.page
      //console.log('page--', this.paginator.paginatorState.page)
    } catch { }

    this.page = this.page < 1 ? 0 : this.page
    this.rows = this.rows < 1 ? 10 : this.rows

    params = params.append('pageNo', this.page.toString());
    params = params.append('pageSize', this.rows.toString());

    let sellOnline = this._filterService.selectedProductSellTypeFilter?.id;
    if (sellOnline) {
      if (sellOnline == 1)
        params = params.append('sellOnline', 'true')
      else if (sellOnline == 2)
        params = params.append('sellOnline', 'false')
    } else {
      sellOnline = 3
      // params = params.append('sellOnline', 'true')
    }

    if (this._filterService.searchText.length > 0) params = params.append('filterValue', this._filterService.searchText);

    const outfilter = {
      // startDate: startDate,
      // endDate: endDate,
      searchText: this._filterService.searchText ? this._filterService.searchText : '',
      selectedProductSellTypeFilter: sellOnline,
      selectedLocation: this._filterService.selectedLocation,

      selectedCategory: this._filterService.selectedCategory,
      selectedVendor: this._filterService.selectedVendor,
      selectedManufacturer: this._filterService.selectedManufacturer,
      selectedDepartment: this._filterService.selectedDepartment,
    }

    this._filterService.updateFilters(this._globals.componentName, outfilter)
    this._filterService.updatePages(this._globals.componentName, { page: this.page, rows: this.rows })


    return params
  }

  async getDataList() {
    this._abd.showSpinner()
    let qryParas = null
    if (this.orderParam && this.orderParam.length > 0) {
      qryParas = `?orderParam=${this.orderParam}&orderBy=${this.orderBy}`
      this._filterService.updateOrderby(this._globals.componentName, { orderParam: this.orderParam, orderBy: this.orderBy })
    }

 
    let url = environment.InventoryBaseURL + environment.GetStockStatusReportV3;
    if (qryParas) url += qryParas

    this._bs.httpGetParams(url, this.makeParams()).subscribe(res => {
      if (res.success) {
        this._abd.hideSpinner()
        this.totalRecords = res.totalRecords
        this.dataList = res.data

        for (let i = 0; i < this.dataList.length; i++) {
          this.dataList[i].selected = false
          this.dataList[i].changedStockInHand = this.getExpectedCountedQty(this.dataList[i])
        }
      }
    })
  }

  clearSearchText() {
    this._abd.searchText = ''
    this.filterButtonPressed()
  }

  filterButtonPressed() {
    const xx = this.isDataChanged()
    if (xx) {
      this._confirmationService.confirm({
        message: 'Data change detected. Proceeding further will lose changes. \nDo you want to proceed without saving?',
        header: 'Proceed Confirmation',
        icon: 'pi pi-times-circle',
        accept: () => {
          this.filterButtonPressedProcess()
          return
        },
        reject: () => {
          return
        }
      });
    } else {
      this.filterButtonPressedProcess()
    }
  }

  filterButtonPressedProcess() {
    for (let i = 0; i < this.dataList?.length; i++) {
      this.dataList[i].selected = false
    }

    this._globals.sleep(500).then(() => {
      this.page = 0
      // this.paginator?.changePage(0)
      try {
        this.paginator?.changePage(0)
      } catch { }
      this.getDataList()
    })

  }

  searchTextSearch() {
    // if (this._abd.searchText.length < 1 && this.lastSearchText.length < 1) return
    if (this._filterService.searchText === this.lastSearchText) return

    this.lastSearchText = this._filterService.searchText
    this.filterButtonPressed()
  }

  async onPageChange(e) {
    // if (e.page === this.page - 1) return
    const xx = await this.isDataChanged()

    if (xx) {
      this._confirmationService.confirm({
        message: 'Data change detected. Proceeding further will loose changes. \nDo you want to proceed without saving?',
        header: 'Proceed Confirmation',
        icon: 'pi pi-times-circle',
        accept: () => {
          e.totalRecords = this.totalRecords
          this.rows = e.rows
          this.page = e.page + 1
          this.getDataList()
        },
        reject: () => {
          try {
            this.paginator.changePage(this.page - 1)
          } catch { }

          return
        }
      });
    } else {
      e.totalRecords = this.totalRecords
      this.rows = e.rows
      this.page = e.page + 1
      this.getDataList()
    }

  }

  selectAllChanged(event) {
    if (event.checked) {
      for (let i = 0; i < this.dataList.length; i++) {
        this.dataList[i].selected = event.checked
      }
    } else {
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.getExpectedCountedQty(this.dataList[i]) !== this.dataList[i].changedStockInHand)
          this.dataList[i].selected = true
        else
          this.dataList[i].selected = false
      }
    }
  }

  stockQuantityChanged(item: any) {
    if (!item) return

    if (this.getExpectedCountedQty(item) !== Number(item.changedStockInHand ?? 0))
      item.selected = true
    else
      item.selected = false
  }

  private getExpectedCountedQty(item: any): number {
    const qtyOnHand = Number(item?.stockInHand ?? 0)
    const sold = Number(item?.usedSince ?? 0)
    const counted = qtyOnHand
    return counted > 0 ? counted : 0
  }

  postInventory() {
    let AdjustInventory = false;
    if (this.autoAdjustQty) {
      this._confirmationService.confirm({
        message: 'Posting Inventory will Adjust the Quantity on Hand. Do you wish to continue? ',
        header: 'Confirmation',
        icon: 'pi pi-info-circle',
        accept: () => {
          this.autoAdjustQty = true;
          this.postInventoryRequest();
        },
        reject: () => { this.autoAdjustQty = false; }
      });
    }
    else {
      this.postInventoryRequest();
    }
  }

  postInventoryRequest() {

    this._abd.showSpinner()
    try {
      let model: any = []
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].selected) {
          model.push({
            locationId: this.dataList[i].locationId.toString(),
            skuCode: this.dataList[i].skuCode,
            quantity: this.dataList[i].changedStockInHand ?? 0,
            productId: this.getInventoryCountSkuId(this.dataList[i]),
            adjustInventory: this.autoAdjustQty
          })
        }
      }
      const outData = {
        data: model
      }
      this._inventoryService.saveInventoryVerificationCount(outData).subscribe(res => {
        if (res.success) {
          // this._abd.hideSpinner()
          this.getDataList()
          this._connMessageService.showToastMessage('Operation successfull', 'success')
        }
      })
    } catch {
      this._abd.hideSpinner()
    }
  }

  private getInventoryCountSkuId(item: any): any {
    return item?.itemSkuId
      ?? item?.itemSKUId
      ?? item?.itemSkuID
      ?? item?.productSkuId
      ?? item?.productSKUId
      ?? item?.skuId
      ?? item?.skuID
      ?? item?.productId
  }

  callbackFuncFromFilter(event) {
    // this.getDataList()
    this.filterButtonPressed()
  }

  exportExcel() {
    // this._globals.exportExcel(this.dataList, this.colflds, 'Inventory Count')
  }

  exportPdf() {
    let data = []

    for (let i = 0; i < this.dataList.length; i++) {
      let row = []
      for (let j = 0; j < this.colflds.length; j++)
        row.push(this.dataList[i][this.colflds[j]])
      data.push(row)
    }

    // this._globals.exportPdf(data, this.colheader, 'Inventory Count')
  }

  isDataChanged(): boolean {
    if (!this.dataList) return false
    let changed = false
    for (let i = 0; i < this.dataList.length; i++) {
      if (this.dataList[i].selected) {
        changed = true
        break
      }
    }
    return changed
  }

  createProduct() {
    this._router.navigateByUrl(this._abd.getCreateProductRoute())
  }

  onRowSelect(e) {
    this.selectedRow = e?.data
  }

  onRowUnselect(e) { }

  openProductDetailsFromRow(item: any, event: MouseEvent): void {
    if (this.isInteractiveRowClick(event?.target)) return
    this.openLatestProductView(item)
  }

  private isInteractiveRowClick(target: any): boolean {
    try {
      const el = target as HTMLElement
      if (!el || !el.closest) return false
      return !!el.closest(
        '.p-checkbox,.p-inputnumber,.p-inputnumber-button,.p-inputtext,button,input,textarea,select,a'
      )
    } catch {
      return false
    }
  }

  private makeProductViewParams(filterValue: any) {
    let params = new HttpParams();
    params = params.append('locationId', '');
    params = params.append('departId', '');
    params = params.append('categoryId', '');
    params = params.append('vendorId', '');
    params = params.append('manufactureId', '');
    params = params.append('pageNo', '0');
    params = params.append('pageSize', '10');
    params = params.append('filterValue', String(filterValue ?? ''));
    return params;
  }

  private openLatestProductView(item: any): void {
    const searchValues = [
      item?.productId,
      item?.id,
      item?.skuCode,
      item?.barcode,
      item?.itemSkuId,
      item?.itemSKUId,
      item?.skuId,
      item?.itemName,
    ]
      .map((value: any) => String(value ?? '').trim())
      .filter((value: string, index: number, values: string[]) => value.length > 0 && values.indexOf(value) === index)

    if (searchValues.length < 1) {
      this._connMessageService.showToastMessage('Product not found.', 'warn')
      return
    }

    this._abd.showSpinner()
    this.openLatestProductViewBySearch(item, searchValues, 0)
  }

  private openLatestProductViewBySearch(sourceItem: any, searchValues: string[], index: number): void {
    const searchValue = searchValues[index]
    if (!searchValue) {
      this._abd.hideSpinner()
      this._connMessageService.showToastMessage('Unable to open product details.', 'warn')
      return
    }

    this._productService.getAllProductList4Inventory(this.makeProductViewParams(searchValue)).subscribe(
      (res: any) => {
        const product = this.findProductForInventoryRow(sourceItem, res?.data)
        if (!res?.success || !product) {
          this.openLatestProductViewBySearch(sourceItem, searchValues, index + 1)
          return
        }

        this._abd.hideSpinner()
        this._productService.activeItem = product
        this._productService.isNew = false
        this._productService.isEdit = false
        this._productService.isViewOnly = true
        this._productService.featureImage = this._productService.activeItem?.image || null
        this._productService.thImages = []
        this._productService.thImageNames = []
        this.showLatestProductPanel = true
      },
      () => {
        this.openLatestProductViewBySearch(sourceItem, searchValues, index + 1)
      }
    )
  }

  private findProductForInventoryRow(sourceItem: any, products: any[]): any {
    if (!Array.isArray(products) || products.length < 1) return null

    const productId = String(sourceItem?.productId ?? sourceItem?.id ?? '').trim()
    const skuCode = String(sourceItem?.skuCode ?? '').trim().toLowerCase()
    const barcode = String(sourceItem?.barcode ?? '').trim().toLowerCase()
    const itemSkuId = String(sourceItem?.itemSkuId ?? sourceItem?.itemSKUId ?? sourceItem?.skuId ?? '').trim()

    const getSkus = (product: any): any[] => {
      const candidates = [product?.crsItemSKUs, product?.itemSKUs, product?.ItemSKUs, product?.skus, product?.SKUs]
      for (const candidate of candidates) {
        if (Array.isArray(candidate)) return candidate
      }
      return []
    }

    const exact = products.find((product: any) => {
      const id = String(product?.id ?? product?.productId ?? '').trim()
      if (productId && id === productId) return true

      return getSkus(product).some((sku: any) => {
        const skuId = String(sku?.id ?? sku?.Id ?? sku?.itemSkuId ?? sku?.itemSKUId ?? '').trim()
        const code = String(sku?.skuCode ?? sku?.SkuCode ?? '').trim().toLowerCase()
        const skuBarcode = String(sku?.barcode ?? sku?.Barcode ?? '').trim().toLowerCase()
        return (!!itemSkuId && skuId === itemSkuId) || (!!skuCode && code === skuCode) || (!!barcode && skuBarcode === barcode)
      })
    })

    return exact || products[0]
  }

  closeLatestProductPanel(): void {
    this.showLatestProductPanel = false
  }

  selectionChanged(event) {
    let ret = false
    if (!event.checked) {
      this.selectAll = this.selectAll ? !this.selectAll : this.selectAll
    }

    for (let i = 0; i < this.dataList.length; i++)
      if (this.dataList[i].selected) {
        ret = true
        break
      }

    if (event.checked) {
      const sel = this.dataList.filter(f => f.selected)
      if (sel.length == this.dataList.length) this.selectAll = true
      else this.selectAll = false
    }

    this._globals.showProductDelButton = ret
  }

  customSort(e) {
    const last = this.orderParam

    switch (e.sortField) {
      case 'itemName':
        this.orderParam = 'title'
        break;
      case 'barcode':
        this.orderParam = 'Barcode'
        break;
      case 'skuCode':
        this.orderParam = 'SkuCode'
        break;
      default:
        this.orderParam = ''
    }

    if (this.orderParam !== '') {
      this.orderBy = e.sortOrder == 1 ? 'asc' : 'desc'
      if (last !== this.orderParam) this.orderBy = 'asc'
      this.getDataList()
    }
  }

}
